import React, { useMemo } from 'react';
import type { CountryFlagProps } from '@components/moleculs/country-flag/types';
import { styled } from 'styled-components';

import { CountryImage } from './styles';

const Molecule: React.FC<CountryFlagProps> = ({ name, className, style }) => {
    const src = useMemo(() => `https://flagcdn.com/w20/${name.toLowerCase()}.png`, [name]);

    if (!name) {
        return <React.Fragment />;
    }

    return <CountryImage className={className} loading='lazy' src={src} alt={name} style={style} />;
};

export const CountryFlag = styled(Molecule)({});
